import { TextTooltip } from '@root/components'
import { getSettingsPageUrl } from '@constants'
import { useBusinessContext } from '@root/context'
import { BankMonitoringVariant } from '@pages/InvoicingPage/useBankMonitoringStatus'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { FaExclamationTriangle } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface Props {
  variant: BankMonitoringVariant
  children?: React.ReactNode
}

export const BankMonitoringHint: React.FC<Props> = ({ variant, children }) => {
  const { slug } = useBusinessContext()
  const { t } = useTranslation()
  const label = t('invoicing.debtCollection.reminders.bankSyncHintLabel')

  return (
    <HintTooltip
      $stretch={Boolean(children)}
      maxWidth={320}
      aria-label={label}
      tooltip={
        <Trans
          i18nKey={
            variant === 'stale'
              ? 'invoicing.debtCollection.reminders.bankSyncStaleTip'
              : 'invoicing.debtCollection.reminders.bankSyncMissingTip'
          }
        >
          <Link to={getSettingsPageUrl(slug, { page: 'integrations' })} />
          <Link to={getSettingsPageUrl(slug, { page: 'holvi' })} />
        </Trans>
      }
    >
      {children ?? <HintIcon aria-hidden />}
    </HintTooltip>
  )
}

const HintTooltip = styled(TextTooltip)<{ $stretch?: boolean }>`
  ${({ $stretch }) =>
    $stretch &&
    css`
      display: flex;
      width: 100%;
      cursor: default;
    `}
`

const HintIcon = styled(FaExclamationTriangle)`
  flex-shrink: 0;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.warning};
  cursor: pointer;
`
